import React, { useState } from "react";

// This Week’s Invitation — gentle, non-productivity weekly view
export default function WeeklyPracticeTab() {
  const [theme, setTheme] = useState(
    "Gently notice one moment of reactivity each day."
  );
  const [notes, setNotes] = useState("");

  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  return (
    <section className="card lg section">
      <div className="section-head">
        <h2 className="h2">This Week’s Invitation</h2>
        <span className="xs muted">
          Not a to-do list — just a direction to lean toward.
        </span>
      </div>

      <label className="sm" style={{ display: "block", marginBottom: 8 }}>
        Weekly theme
        <textarea
          className="input"
          rows={2}
          value={theme}
          onChange={(e) => setTheme(e.target.value)}
          style={{ marginTop: 4 }}
        />
      </label>

      <div
        className="grid"
        style={{ gridTemplateColumns: "repeat(7, minmax(0, 1fr))", gap: 8 }}
      >
        {days.map((d) => (
          <div key={d} className="card" style={{ borderRadius: 12 }}>
            <div className="sm" style={{ fontWeight: 600, marginBottom: 4 }}>
              {d}
            </div>
            <p className="xs muted" style={{ margin: 0 }}>
              Notice one moment today when you could pause before reacting.
            </p>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 16 }}>
        <label className="sm" style={{ display: "block", marginBottom: 4 }}>
          Reflections from this week
        </label>
        <textarea
          className="input"
          rows={4}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="What did you notice about your patterns, reactions, and capacity to pause?"
        />
      </div>
    </section>
  );
}
